<template>
  <div>
    <div class="menu-content" @click="onClick">
      <div class="menu-label-item" :style="`padding-left: ${20 * node}px`">
        <span class="icon">
          <svg v-if="appAccess.children"
               style="width: 24px; height: 24px"
               viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10,17L15,12L10,7V17Z"
                v-if="!showOptions"/>
            <path
                fill="currentColor"
                d="M7,10L12,15L17,10H7Z"
                v-if="showOptions"/>
          </svg>
        </span>
        {{ appAccess.app.label }}
      </div>
      <div class="menu-options" v-if="!appAccess.children">
        <CheckboxCustom
            v-model="appAccess.permissions.read"
            label="Consultar"/>
        <CheckboxCustom
            v-model="appAccess.permissions.write"
            label="Escribir"/>
        <CheckboxCustom
            v-model="appAccess.permissions.update"
            label="Actualizar"/>
        <CheckboxCustom
            v-model="appAccess.permissions.delete"
            label="Eliminar"/>
      </div>
    </div>
    <fieldset class="suboptions" v-if="showOptions">
      <div v-for="subItem in appAccess.children">
        <menu-option
            :app-access="processInfo(subItem)"
            :node="node + 1"/>
      </div>
    </fieldset>
  </div>
</template>
<script>
import CheckboxCustom from "@/components/Shared/CheckboxCustom";

export default {
  name: "MenuOption",
  props: ["appAccess", "node"],
  components: {CheckboxCustom},
  data() {
    return {
      showOptions: false
    };
  },
  beforeMount() {
   this.processInfo(this.appAccess);
   this.showOptions = this.appAccess.showOptions ? this.appAccess.showOptions : false;
  },
  methods: {
    onClick() {
      const children = this.appAccess.children;
      if (children && children.length > 0) {
        const change = !this.showOptions;
        this.showOptions = change;
        this.appAccess.showOptions = change;
      }
    },
    processInfo(item) {
      if (!item.permissions) {
        item.permissions = {
          read: false,
          delete: false,
          write: false,
          update: false
        };
      }
      return item;
    }
  },
};
</script>
